import { Typography } from '@design-system/components/typography/typography';
import { AuthorId } from '../model/post.types';
import {
  ChallengeRef,
  useAuthorChallengeParticipation,
} from '../api/useAuthorChallengeParticipation';

type Props = {
  authorId: AuthorId;
  open: boolean;
};

const ChallengeList = ({
  label,
  items,
}: {
  label: string;
  items: ChallengeRef[];
}) => (
  <div className="flex flex-col gap-0.5">
    <Typography as="span" variant="body" size="small" className="font-semibold">
      {label}
    </Typography>
    {items.length === 0 ? (
      <Typography
        as="span"
        variant="body"
        size="small"
        className="text-[#6B7280]"
      >
        None
      </Typography>
    ) : (
      <ul className="list-disc pl-5">
        {items.map((item) => (
          <li key={item.id}>
            <Typography as="span" variant="body" size="small">
              {item.name}
            </Typography>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export const ChallengeParticipationSection = ({ authorId, open }: Props) => {
  const participation = useAuthorChallengeParticipation(authorId, open);

  const renderContent = () => {
    switch (participation.type) {
      case 'fetch-error':
        return (
          <Typography
            as="span"
            variant="body"
            size="small"
            className="text-[#E5322D]"
          >
            Could not load challenges
          </Typography>
        );
      case 'fetched':
        return (
          <>
            <ChallengeList label="Active" items={participation.value.active} />
            <ChallengeList
              label="Inactive"
              items={participation.value.inactive}
            />
          </>
        );
      default:
        return (
          <Typography
            as="span"
            variant="body"
            size="small"
            className="text-[#6B7280]"
          >
            Loading...
          </Typography>
        );
    }
  };

  return (
    <div
      className="mt-4 flex flex-col gap-2 border-t border-[#ECEDF2] pt-4"
      data-testid="user-profile-modal-challenges"
    >
      <Typography as="h5" variant="body" className="font-semibold">
        Challenges
      </Typography>
      {renderContent()}
    </div>
  );
};
